export default __webpack_public_path__ + "static/SONY_WDR_STRENGTH_5-0a75d77e4e858e60ea93b6d95d60a94a.webp";